// import shelf from '@/assets/shelf.png'
import { cgateFetch, getCgateToken, getTenantId, isTest } from './cgate_util'

const mainShare = {
  shelf: 'https://cdn-static.xiaoduoai.com/xiaoduo-front-ums/permanent/shelf.png',
  getCgateToken,
  getTenantId,
  isTest,
  cgateFetch,
}
type MainShare = typeof mainShare
export type { MainShare }
export default mainShare
